import placeOrderMutation from '@/queries/mutations/placeOrder.graphql';

export const state = () => ({
    order: {},
    success: false,
    loading: false,
});
export const mutations = {
    set_success(state, value) {
        state.success = value;
    },
    set_order(state, value) {
        state.order = value;
    },
    set_loading(state, value) {
        state.loading = value;
    },
};
export const actions = {
    setLoading({ commit }, value) {
        commit('set_loading', value);
    },
    /**
     * @see https://devdocs.magento.com/guides/v2.4/graphql/mutations/place-order.html
     * Create an empty cart
     * Add one or more products to the cart
     * Set the billing address
     * Set the shipping address
     * Set the shipping method
     * Set the payment method
     * For guest customers, assign an email to the cart
     * @returns {Promise<{order_number: *, errors: ReadonlyArray<GraphQLError>}>}
     */
    async placeOrder({ commit }) {
        try {
            const client = this.app.apolloProvider.defaultClient;
            const cartId = this.$storage.getCookie('cart_id');
            const {
                data: {
                    placeOrder: { order: order_number },
                    redirect,
                },
                errors,
            } = await client.mutate({
                mutation: placeOrderMutation,
                variables: { cartId },
            });
            commit('set_success', true);

            return { order_number, errors, redirect };
        } catch (e) {
            throw new Error(e.message);
        }
    },
};

export const getters = {
    loading: (state) => state.loading,
};
